import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortMyRequestComponent } from './port-my-request.component';

const routes: Routes = [
  {
    path: '',
    component: PortMyRequestComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortMyRequestRoutingModule {}
